import { Pipe, PipeTransform } from '@angular/core';
import { Observable, Subscriber, of, take } from 'rxjs';

@Pipe({
  name: 'fileToBase64Async',
})
export class FileToBase64Pipe implements PipeTransform {
  transform(file: File | string): Observable<string | null> {
    if (!file) return of(null);
    if (typeof file === 'string') return of(file).pipe(take(1));

    return new Observable<string>((observer: Subscriber<string>) => {
      const reader: FileReader = new FileReader();
      reader.onload = (): void => {
        observer.next(reader.result as string);
        observer.complete();
      };
      reader.onerror = (error: ProgressEvent): void => {
        observer.error(error);
      };
      reader.readAsDataURL(file);
    });
  }
}
